export default __webpack_public_path__ + "static/media/Ellipse 22 (1).e01235c6.png";